import { api, getAuthHeader } from "../axiosConfig";
import { notifyService } from "./notifyService";

export async function getDefinitions() {
  return await api
    .get("/settings/definitions", { headers: getAuthHeader() })
    .then((res) => res.data)
    .catch(() => null);
}

export async function addDefinition(data) {
  return await api
    .post("/settings/definitions", data, { headers: getAuthHeader() })
    .then((res) => {
      notifyService("Custom field added");
      return res.data;
    })
    .catch((err) => {
      notifyService(err.response?.data || "Failed to add custom field");
      return null;
    });
}

export async function updateDefinition(id, data) {
  return await api
    .put(`/settings/definitions/${id}`, data, { headers: getAuthHeader() })
    .then((res) => {
      notifyService("Custom field updated");
      return res.data;
    })
    .catch((err) => {
      notifyService(err.response?.data || "Failed to update custom field");
      return null;
    });
}

export async function getCounties() {
  return await api
    .get("/settings/counties", { headers: getAuthHeader() })
    .then((res) => res.data)
    .catch(() => null);
}

export async function addCounty(data) {
  return await api
    .post("/settings/counties", data, { headers: getAuthHeader() })
    .then((res) => {
      notifyService("County added");
      return res.data;
    })
    .catch((err) => {
      notifyService(err.response?.data || "Failed to add county");
      return null;
    });
}

export async function updateCounty(id, data) {
  return await api
    .put(`/settings/counties/${id}`, data, { headers: getAuthHeader() })
    .then((res) => {
      notifyService("County updated");
      return res.data;
    })
    .catch((err) => {
      notifyService(err.response?.data || "Failed to update county");
      return null;
    });
}

export async function deleteCounty(id) {
  return await api
    .delete(`/settings/counties/${id}`, { headers: getAuthHeader() })
    .then(() => {
      notifyService("County deleted");
      return true;
    })
    .catch((err) => {
      notifyService(err.response?.data || "Failed to delete county");
      return false;
    });
}
